// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "card-oXFhC";
export { _1 as "__esModule", _2 as "card" }
export default { "__esModule": _1, "card": _2 }
